import { render, staticRenderFns } from "./DocumentPublishedHistoryViewerDialog.vue?vue&type=template&id=5d9aaedd&scoped=true&"
import script from "./DocumentPublishedHistoryViewerDialog.vue?vue&type=script&lang=ts&"
export * from "./DocumentPublishedHistoryViewerDialog.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentPublishedHistoryViewerDialog.vue?vue&type=style&index=0&id=5d9aaedd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9aaedd",
  null
  
)

export default component.exports